
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7f11fb8e!sass-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Notifications.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Notifications.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7f11fb8e!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Notifications.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/UIComponents/NotificationPlugin/Notifications.vue
// module id = 526
// module chunks = 1